import React from 'react';
import { Navigate } from 'react-router-dom';
import { canEditContent } from '../../utils/permissions';

const EditProtectedRoute = ({ children, appName, fallbackPath = '/' }) => {
  // If user can't edit, redirect them back
  if (!canEditContent(appName)) {
    return <Navigate to={fallbackPath} replace />;
  }
  
  return children;
};

export default EditProtectedRoute; 